import styled, { keyframes } from "styled-components";

const frames = keyframes`
    0% {
        transform:scale(1);
    }
    5% {
        transform:scale(1.25);
    }
    20% {
        transform:scale(1);
    }
    30% {
        transform:scale(1);
    }
    35% {
        transform:scale(1.25);
    }
    50% {
        transform:scale(1);
    }
    55% {
        transform:scale(1.25);
    }
    70% {
        transform:scale(1);
    }
    75% {
        transform:scale(1.25);
    }
`;

export const BeatImg = styled.img`
    animation: ${frames} 3s ease infinite;

    margin: 1vw 1vw 1vw 1%;
    width: 160px;
    height: 70px;
    object-fit: contain;

    @media (max-width: 1250px) {
        margin: 1vw 1vw 1vw 1%;
    }
`;

interface Props {
    src: string;
}

const BeatSpinner: React.FC<Props> = ({ src }) => (
    <BeatImg src={src} alt="BeatSpinner" />
);

export default BeatSpinner;
